import { render, staticRenderFns } from "./DoctorReportCard.vue?vue&type=template&id=251a1b2c&scoped=true"
import script from "./DoctorReportCard.vue?vue&type=script&lang=ts"
export * from "./DoctorReportCard.vue?vue&type=script&lang=ts"
import style0 from "./DoctorReportCard.vue?vue&type=style&index=0&id=251a1b2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251a1b2c",
  null
  
)

export default component.exports